import {stringify} from 'qs'
import {format} from 'utils'
import request from 'crm/utils/request'
import api from '../api/drainage'

// 门店引流码列表
export async function storeDrainageCode(payload) {
    return request(
        `${format(api.storeDrainageCode.url, {id: payload.id})}${stringify(payload.params, {
            addQueryPrefix: true,
        })}`,
    )
}

export async function storeChannels(params) {
    return request(`${api.storeChannels.url}${stringify(params, {addQueryPrefix: true})}`)
}

export async function updateStoreDrainageCode(payload) {
    return request(api.updateStoreDrainageCode.url, {
        method: api.updateStoreDrainageCode.type,
        body: payload.body,
    })
}

export async function updateGroupChatLink(payload) {
    return request(api.updateGroupChatLink.url, {
        method: api.updateGroupChatLink.type,
        body: payload.body,
    })
}
